// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cwb__toolbar {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 500;

  display: flex;
  flex-direction: column;
  background-color: #efefef;
  padding: 4px;
  border-radius: 0 4px 4px 0;
  align-items: center;
  gap: 4px;
}

.cwb_toolbar_separator {
  width: 60%;
  height: 0.5px;
  background-color: #b0b0b0;
  margin: 6px 0;
}

.cwb__toolbar {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 500;

  display: flex;
  flex-direction: column;
  background-color: #efefef;
  padding: 4px;
  border-radius: 0 4px 4px 0;
  align-items: center;
  gap: 4px;

  transition: all 0.3s ease;
}

/* Responsive: herramientas arriba dentro del contenedor */
@media (max-height: 500px) {
  .cwb__toolbar {
    top: 0;
    left: 0;
    transform: none;

    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    border-radius: 0 0 4px 0;
    padding: 4px;
  }

  .cwb_toolbar_separator {
    width: 0.5px;
    height: 24px;
    margin: 0 6px;
  }
}

`, "",{"version":3,"sources":["webpack://./react/features/whiteboard/custom-ui/styles/toolbar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,QAAQ;;EAER,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;EACE;IACE,MAAM;IACN,OAAO;IACP,eAAe;;IAEf,mBAAmB;IACnB,eAAe;IACf,2BAA2B;IAC3B,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":[".cwb__toolbar {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  z-index: 500;\n\n  display: flex;\n  flex-direction: column;\n  background-color: #efefef;\n  padding: 4px;\n  border-radius: 0 4px 4px 0;\n  align-items: center;\n  gap: 4px;\n}\n\n.cwb_toolbar_separator {\n  width: 60%;\n  height: 0.5px;\n  background-color: #b0b0b0;\n  margin: 6px 0;\n}\n\n.cwb__toolbar {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  z-index: 500;\n\n  display: flex;\n  flex-direction: column;\n  background-color: #efefef;\n  padding: 4px;\n  border-radius: 0 4px 4px 0;\n  align-items: center;\n  gap: 4px;\n\n  transition: all 0.3s ease;\n}\n\n/* Responsive: herramientas arriba dentro del contenedor */\n@media (max-height: 500px) {\n  .cwb__toolbar {\n    top: 0;\n    left: 0;\n    transform: none;\n\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    border-radius: 0 0 4px 0;\n    padding: 4px;\n  }\n\n  .cwb_toolbar_separator {\n    width: 0.5px;\n    height: 24px;\n    margin: 0 6px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
